<script lang="ts">
 import type { Report } from '#lib/types';
 import { CATEGORIES } from '#lib/analytics/schema';
 import { t } from '#lib/i18n/state.svelte';
 import LangToggle from './LangToggle.svelte';
 let {report,onreset,onlogin,waiting=false,quota=false}:{report:Report;onreset:()=>void;onlogin:()=>void;waiting?:boolean;quota?:boolean}=$props();
 const total=$derived(report.counts.critical+report.counts.warning+report.counts.info);
</script>
<svelte:head><title>{t('preview.title')} — RepCheck</title></svelte:head>
<div class="preview-shell">
 <header><a href="/" class="brand">RepCheck</a><LangToggle compact /></header>
 <main>
  <p class="eyebrow">{t('preview.eyebrow')}</p>
  <h1>{t('preview.title')}</h1>
  <p class="total"><strong>{total}</strong> {t('preview.findings')}</p>
  <div class="severity-grid">
   <div><strong>{report.counts.critical}</strong><span>{t('severity.critical')}</span></div>
   <div><strong>{report.counts.warning}</strong><span>{t('severity.warning')}</span></div>
   <div><strong>{report.counts.info}</strong><span>{t('severity.info')}</span></div>
  </div>
  <section aria-label={t('preview.categories')}>
   <h2>{t('preview.categories')}</h2>
   {#each CATEGORIES as category}
    <div class="category-row"><span>{t('category.'+category)}</span><strong>{report.issues.filter(i=>i.category===category&&i.severity!=='ok').length}</strong></div>
   {/each}
  </section>
  <div class="unlock">
   <h2>{t('preview.unlockTitle')}</h2>
   <p>{t(quota?'preview.quota':'preview.unlockBody')}</p>
   <a class="btn btn-primary" href="/api/auth/login/libedge?flow=preview" target="_blank" rel="noopener" onclick={onlogin}>{t('auth.libedge')}</a>
   <a class="btn btn-ghost" href="/api/auth/login/google?flow=preview" target="_blank" rel="noopener" onclick={onlogin}>{t('auth.google')}</a>
   {#if waiting}<p class="waiting" role="status">{t('preview.waiting')}</p>{/if}
  </div>
  <p class="privacy">{t('preview.privacy')}</p>
  <button class="btn btn-ghost" onclick={onreset}>{t('preview.another')}</button>
 </main>
</div>
<style>
 .preview-shell{min-height:100vh;background:var(--paper);color:var(--ink);}
 header{display:flex;justify-content:space-between;align-items:center;padding:1rem clamp(1rem,4vw,3rem);border-bottom:1px solid var(--line);}
 .brand{font-weight:700;color:var(--ink);text-decoration:none;}
 main{max-width:48rem;margin:3rem auto;padding:0 1.25rem 3rem;}
 .eyebrow{font-size:.75rem;letter-spacing:.12em;text-transform:uppercase;color:var(--muted);}
 h1{font-size:clamp(1.8rem,5vw,2.7rem);margin:.5rem 0;}
 .total{font-size:1.15rem;color:var(--ink-2);}
 .total strong{font-size:3rem;color:var(--ink);font-family:var(--font-display);}
 .severity-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:.75rem;margin:1.5rem 0 2rem;}
 .severity-grid div{display:grid;gap:.4rem;padding:1.2rem;border:1px solid var(--line);border-radius:var(--radius);background:white;}
 .severity-grid strong{font-size:1.8rem;}
 .severity-grid span{font-size:.85rem;color:var(--muted);}
 h2{font-size:1.1rem;}
 .category-row{display:flex;justify-content:space-between;gap:1rem;padding:.8rem 0;border-bottom:1px solid var(--line);}
 .unlock{margin-top:2rem;padding:1.5rem;background:white;border:1px solid var(--line);border-radius:var(--radius);box-shadow:var(--shadow-sm);}
 .unlock p{color:var(--ink-2);line-height:1.6;}
 .unlock .btn{text-decoration:none;display:inline-flex;text-align:center;justify-content:center;}
 .privacy,.waiting{font-size:.82rem;line-height:1.6;color:var(--muted);}
 @media(max-width:480px){.severity-grid{gap:.4rem;}.severity-grid div{padding:.8rem;}.severity-grid span{font-size:.75rem;}}
</style>
